<template>
  <div class="content-bg" style="margin-top:20px;">
    <div class="content" style="background: white">
      <div class="row">
        <div class="col-xs-3">
          <div class="left-nav">
            <ul>
              <li class="title">
                <a href="#">机构简介</a>
              </li>
            </ul>
            <ul>
              <li>
                <a
                  :class="num===0? 'newsytle':''"
                  href="javascript:;"
                  @click="getLdInfo"
                  >领导班子</a
                >
              </li>
              <li >
                <a
                  :class="num===1? 'newsytle':''"
                  @click="getZuInfo"
                  href="javascript:;"
                  >主要职责</a
                >
              </li>
              <li>
                <a
                  :class="num===2? 'newsytle':''"
                  @click="getYwInfo"
                  href="javascript:;"
                  >业务简介</a
                >
              </li>
              <li>
                <a
                  :class="num===3? 'newsytle':''"
                  href="javascript:;"
                  @click="getJcInfo"
                  >检测室简介</a
                >
              </li>
              <li >
                <a
                  :class="num===4? 'newsytle':''"
                   href="javascript:;"
                  @click="getYqInfo"
                  >仪器设备</a
                >
              </li>
            </ul>
          </div>
        </div>

        <div class="col-xs-9">
          <div class="index-middle" style="border: none">
            <div class="module-head" style="background: white">
              <span
                class="title"
                style="color: #0d4c99; font-size: 18px; width: 135px;margin-left:-490px" 
                >{{columnName}}</span
              >
              <div class="he">
                <span style="color: #999999">>></span>
                <span>
                  <a class="hh" href="javascript:;"
                    >首页</a
                  >
                </span>
                <span style="color: #999999">>></span>
                <span>
                  <a
                    class="hh"
                    href="javascript:;"
                    >机构简介</a
                  >
                </span>
                <span style="color: #999999">>>></span>
                <span>
                  <a
                    class="hh"
                    href="javascript:;"
                    >{{columnName}}</a
                  >
                </span>
              </div>
            </div>

            <div class="module-table-outer">
              <!--领导班子 -->
              <div class="in_01c_c" v-if="num==0">
                <div
                  class="row"
                  v-for="(item,index) in childrenList" :key="index"
                  style="height: 242px; border: 1px solid #cccccc"
                >
                  <div class="col-xs-3" style="background: #eeeeee; width: 22%">
                    <div class="photo">
                      <img
                        :src="item.contentUrl"
                      />
                    </div>
                  </div>
                  <div class="col-xs-9" style="width: 78%" v-html="item.content">
                    
                  </div>
                </div>
                <!-- <div
                  class="row"
                  style="height: 242px; border: 1px solid #cccccc"
                >
                  <div class="col-xs-3" style="background: #eeeeee; width: 22%">
                    <div class="photo">
                      <img
                        src="http://www.gxlyzjz.cn:4221/u/cms/www/201906/24174857hkui.jpg"
                      />
                    </div>
                  </div>
                  <div class="col-xs-9" style="width: 78%">
                    <p style="text-indent: 43px">
                      <span style="font-size: 21px; font-family: 仿宋_GB2312"
                        >张斌，男，1980年8月生，汉族，河南长垣县人，2002年12月加入中国共产党，2007年7月参加工作，南昌大学研究生毕业，农学硕士，讲师。现任广西壮族自治区粮油质量检验中心党支部副书记、副主任。</span
                      >
                    </p>
                    <p style="text-indent: 43px">
                      <span style="font-size: 21px; font-family: 仿宋_GB2312"
                        >分管自治区粮油质量检验中心业务部、检验部。</span
                      >
                    </p>
                  </div>
                </div> -->
              </div>
              <!--主要职责 -->
              <div class="Dutytext" v-if="num==1" v-html="content">
              
              </div>
              <!--业务简介 -->
              <div class="Dutytext" v-if="num==2" v-html="content">
                
              </div>
              <!--检测室简介 -->
              <div class="Dutytext" v-if="num==3" v-html="content">
                
              </div>
              <!--仪器设备 -->
              <div v-if="num==4">
                <div class="row" v-for="(item,index) in childrenList" :key="index">
                  <div class="inst">
                    <div class="p-picture">
                      <img
                        :src="item.contentUrl"
                        width="120"
                        height="120"
                      />
                    </div>
                  </div>
                  <div class="col-xs-9" style="width: 85%">
                    <div class="newname">
                      <a
                        href="javascript:;"
                        :title="item.articleTitle"
                        target="_blank"
                        >粮油仪器设备</a
                      >
                    </div>
                    <p class="newline">{{item.articleTitle}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getJgjjData } from "@/api/content/column";
export default {
  data() {
    return {
        jjId:0,
        num:0,
        columnName:'',
        leadershipList:null,
        content:null,
        childrenList:[],
    };
  },
  created(){
    this.init();
  }, 
  methods: {
    toDetails(index) {
      this.$router.push({path:"/Aitrcle/Details",query:{id:"页面跳转成功"}});
    },
    init(){
        this.jjId=this.$route.query.id;
        getJgjjData(this.jjId).then(response=>{
          this.num=0;  
          this.leadershipList = response.data;
          this.childrenList=this.leadershipList.children;
          this.columnName=this.leadershipList.label;
        })
    },
    getLdInfo(){
        this.jjId=32;
        getJgjjData(this.jjId).then(response=>{
          this.num=0;  
          this.leadershipList = response.data;
          this.childrenList=this.leadershipList.children;
          this.columnName=this.leadershipList.label;
        })
    },
    getZuInfo(){
        this.jjId=33;
        getJgjjData(this.jjId).then(response=>{
          this.num=1;  
          this.leadershipList = response.data;
          this.childrenList=this.leadershipList.children;
          if(this.leadershipList.children.length<=0){
            this.content="";
          }else{
            this.content=this.leadershipList.children[0].content;
          }
          this.columnName=this.leadershipList.label;
        })
    },
    getYwInfo(){
        this.jjId=34;
        getJgjjData(this.jjId).then(response=>{
          this.num=2;  
          this.leadershipList = response.data;
          this.childrenList=this.leadershipList.children;
          if(this.leadershipList.children.length<=0){
            this.content="";
          }else{
            this.content=this.leadershipList.children[0].content;
          }
          this.columnName=this.leadershipList.label;
        })
    },
    getJcInfo(){
        this.jjId=35;
        getJgjjData(this.jjId).then(response=>{
          this.num=3;  
          this.leadershipList = response.data;
          this.childrenList=this.leadershipList.children;
          if(this.leadershipList.children.length<=0){
            this.content="";
          }else{
            this.content=this.leadershipList.children[0].content;
          }
          this.columnName=this.leadershipList.label;
        })
    },
    getYqInfo(){
        this.jjId=36;
        getJgjjData(this.jjId).then(response=>{
          this.num=4;  
          this.leadershipList = response.data;
          this.childrenList=this.leadershipList.children;
          this.columnName=this.leadershipList.label;
        })
    },
  },
};
</script>

<style scoped>
@import "../styles/home.css";
@import "../styles/pages.css";
@import "../styles/style.css";
.newsytle{
      color:red
    }
</style>


// WEBPACK FOOTER //
// src/components/jgjj.vue